import React, {useEffect, useState} from 'react';
import {InfoPopover, RadioGroup, RedAsterisk} from "../../../../components";
import useProfileEditableState from "../../../../hooks/useProfileEditableState";
import {useAppSelector} from "../../../../store/hooks";
import {saveSelector} from "../../../slices/NavigationSlice";
import {isValid} from "../../../validation/ValidationUtils";
import "./_radio-group-field.scss";
import {useAnalyticsTrackers} from "../../../../utils/useAnalyticsTrackers";

interface RadioGroupFieldProps {
    id: string;
    label: string;
    values: string[];
    selectedValue: string;
    onChange: (selection: string) => void;
    tooltipContent?: JSX.Element;
    required?: boolean;
    className?: string;
    subtext?: string;
}

function RadioGroupField({
                             id,
                             label,
                             values,
                             selectedValue,
                             onChange,
                             tooltipContent,
                             required = false,
                             className = "",
                             subtext
                         }: Readonly<RadioGroupFieldProps>) {

    const saveHasBeenClicked = useAppSelector(saveSelector);
    const {isProfileWithProposalsOrArchived} = useProfileEditableState();
    const [hasError, setHasError] = useState<boolean>(false);
    const {page} = useAnalyticsTrackers();

    useEffect(() => {
        setHasError((required ?? false) && saveHasBeenClicked && !isValid(selectedValue))
    }, [required, saveHasBeenClicked, selectedValue]);

    useEffect(() => {
        if (saveHasBeenClicked) {
            page(`DEF_GST_Selection_${selectedValue}`, {cd13_gst_tag: selectedValue});
        }
    }, [saveHasBeenClicked]);

    return (
        <div className={`layout-data-entry-form__field radio radio-group-field ${className}`}>
            <label className={"radio-group-label"}>
                <h5>
                    {label}
                    {required && <RedAsterisk/>}
                    {tooltipContent && <InfoPopover
                        arrow={true}
                        content={tooltipContent}
                        direction="right"
                        label="tags-trusts-tooltip"
                        size={"medium"}
                        width={'332px'}
                        className="tooltip-trusts-tags-section"/>
                    }
                </h5>
                {subtext && <span className="textarea-sub-text input__info margintop-sm">{subtext}</span>}
            </label>
            <RadioGroup
                name={id}
                id={id}
                className='radio-group'
                layout='vertical'
                values={values}
                disabled={isProfileWithProposalsOrArchived}
                onChange={(e) => {
                    onChange((e.target as HTMLInputElement).value)
                }}
                required={required}
                selected={selectedValue}
                data-testid={id}
                error={hasError}
            />
            {hasError && <div className='input__info color-text--error'>GST Tags is required.</div>}
        </div>
    );
}

export default RadioGroupField;